import usConfig from './us';
import euConfig from './eu';
import qaConfig from './qa';
import { isBrowser, isProduction } from './environment';
var localConfigs = {
  QA: qaConfig,
  EU: euConfig,
  US: usConfig
};
export default Object.assign(Object.assign({}, isBrowser && window.DRIFT_CONFIG || {}), localConfigs[isBrowser && window.DRIFT_REGION || (isProduction ? 'US' : 'QA')]);